module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Menu planning")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAKFAST IS USUALLY")]), _vm._v(" a miniature affair consisting of hors d’œuvres such as cheese, yoghurt, olives (mainly black), Lebanese bread or toast with clotted cream and preserves. Sometimes a fried egg in butter or a hard-boiled egg is prepared. There is usually a zaatar (thyme and cumin) mixture on the table. Breakfast is rounded off with coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main meal of the day used to be served at lunchtime, but in accordance with modern lifestyles, is now served in the evenings. There is always an hors d’œuvre served with a drink beforehand.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Page numbers refer to recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("meat pies ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("tomato and cucumber salad dressed with oil, lemon juice, salt and pepper ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("bread ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("), olives ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#page_19"
    }
  }, [_vm._v("here")]), _vm._v(") and cheese")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("green bean stew with lamb ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("rice with vermicelli ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("tomato salad ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("yoghurt ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("), fruit and coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("omelette with courgettes ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("yoghurt ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("bread ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("), olives ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#page_19"
    }
  }, [_vm._v("here")]), _vm._v(") and cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fruit and tea or coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("rice with chicken ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("chickpeas with sesame paste ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("tomato salad ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fruit, cheese and olives")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("cracked wheat salad ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("yoghurt ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fruit and coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("baked fish in sesame sauce ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("rice")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("plain fried aubergines ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("green salad")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fresh fruit and coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("grilled meat ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("cabbage salad ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("bread and sliced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fruit and coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("yoghurt soup ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("stuffed courgettes ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("stuffed aubergines ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fresh fruit and coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("potatoes with chickpeas ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("avocado salad ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("bread ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("), cheese, olives ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#page_19"
    }
  }, [_vm._v("here")]), _vm._v(") and coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("noodles with lentils ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("yoghurt ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fresh fruit")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("sweetmeats ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("stuffed vine leaves ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("baked kibbi ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("cucumber with yoghurt ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_104b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("coffee")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "para-2"
  }, [_c('strong', [_vm._v("Hafla")]), _vm._v(" "), _c('span', {
    staticClass: "f"
  }, [_vm._v("– A party or celebration. Have a finger meal where all the hors d’œuvres can be prepared beforehand. Most of them freeze well. Set the table the day before and enjoy your party!")])]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("    Here are a few suggestions:")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("pickled turnips ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#page_13"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("Pickled cucumbers ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#page_14a"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("pickled onions ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#page_17"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("pickled sweet peppers ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#page_16a"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings1"
  }, [_vm._v("Arrange the pickles attractively on a platter. Chop parsley, mint and basil leaves together and sprinkle over the pickles to add colour. Slice tomatoes and arrange overlapping around the edge of the plate. Place a slice of fresh cucumber on each tomato round and sprinkle with chopped parsley and paprika.")]), _vm._v(" "), _c('p', {
    staticClass: "ings1"
  }, [_vm._v("meat pies ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("spinach pies ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("avocado salad ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("chickpeas with sesame paste ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("aubergine with sesame paste ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("hard-boiled eggs with cumin ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fried fish ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("Surround fish with little bowls of taratoor ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("fried chicken ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("raw kibbi ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("Surround kibbi with lettuce leaves and place a basket of bread next to it.")]), _vm._v(" "), _c('p', {
    staticClass: "ings1"
  }, [_vm._v("baked stuffed kibbi ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#page_66a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("stuffed vine leaves ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("stuffed cabbage leaves ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings1"
  }, [_vm._v("Bread is an integral part of a finger meal and should be placed within easy reach. On another table place an urn of boiling water and coffee, Turkish delight and sugar-coated almonds (these can be bought).")]), _vm._v(" "), _c('p', {
    staticClass: "ings1"
  }, [_vm._v("Try and make the following treats beforehand: semolina cookies ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") Lebanese lovers’ shortbread ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("Pile these in a pyramid, sprinkling lots of icing sugar on each layer.")]), _vm._v(" "), _c('p', {
    staticClass: "ings"
  }, [_vm._v("filo pastry ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(")")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1800011b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 78
// module chunks = 0